import { RechargeFormProvider } from '../../hooks/useRechargeForm'
import Form from './Form'

const FormRechargeIndex = () => (
  <RechargeFormProvider>
    <Form />
  </RechargeFormProvider>
)

export default FormRechargeIndex
